import { render } from "./CheckboxInput.vue?vue&type=template&id=5ba85061&scoped=true&ts=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts"

import "./checkbox-input.scss?vue&type=style&index=0&id=5ba85061&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba85061"]])

export default __exports__